import React, { ReactNode } from 'react';
import { EntityType } from '../../@types/entityTypes';
import { BasicHeader } from '../../actions/BasicHeader';
import { ReportOutputType } from '../../graphql/schema/p4types';
import { useFormContext } from 'react-hook-form';

import { IDocumentValues } from './documentCarouselUtil';

const DocumentCarouselHeader = ({
  entity,
  count,
  secondaryTitle,
  reprint,
}: {
  entity: EntityType;
  count: number;
  secondaryTitle: ReactNode;
  reprint: boolean;
}) => {
  const { watch } = useFormContext<IDocumentValues>();

  let printAction = reprint ? 'Resend/Reprint' : 'Send/Print';
  if (watch('overrideOutput')) {
    switch (watch('outputType')) {
      case ReportOutputType.Email:
        printAction = reprint ? 'Resend' : 'Send';
        break;
      default:
        printAction = reprint ? 'Reprint' : 'Print';
    }
  }

  return (
    <BasicHeader secondaryTitle={secondaryTitle}>
      {count !== undefined
        ? `${printAction} ${entity.title!.toLowerCase()} (${count} records)`
        : `${printAction} ${entity.title!.toLowerCase()}`}
    </BasicHeader>
  );
};

export default DocumentCarouselHeader;
